<template>
  <div class="digest-card">
    <div class="digest-card__header" @click="gotoDigest">
      <div>
        <p class="paragraph--small text--dark-blue bold--lite">
          Аналитический дайджест
        </p>
        <p class="text--dark-grey paragraph--extra-small">
          {{ digest.group_month | getMonth }} {{ digest.group_year }}
        </p>
      </div>
      <img
        src="https://www.1cb.kz/logos/logo-main.svg"
        alt=""
        class="digest-card__logo"
      />
    </div>
    <div class="digest-card__body" @click="gotoDigest">
      <div class="digest-card__info">
        <div class="text--white" v-html="digest.description"></div>
        <!-- <p class="text--white bold">Кредитование ИП:</p>
        <p class="text--white">Большой потенциал Малого Бизнеса</p> -->
      </div>
      <div class="digest-card__illust-wrapper">
        <!-- <img
          src="../../../assets/illustrations/digest-illust.png"
          class="digest-card__illust"
          alt=""
        /> -->
        <img :src="getImage()" class="digest-card__illust" alt=""/>
      </div>
    </div>
    <p class="digest-card__title mt--2 mb--2" @click="gotoDigest">
      <b class="text--dark-blue">Аналитический дайджест</b>
      <span class="text--dark-grey ml--1">
        {{ digest.group_month | getMonth }} {{ digest.group_year }}
      </span>
    </p>
    <div class="digest-card__controller mt--auto">
      <DigestButton :digest="digest" downloadable class="digest-card__button"
      >Скачать краткую версию
      </DigestButton
      >
      <DigestButton @click="showModal" class="digest-card__button"
      >Скачать полную версию
      </DigestButton
      >
    </div>
  </div>
</template>

<script>
import DigestButton from "@/components/common/DigestButton.vue";

export default {
  components: {
    DigestButton,
  },
  props: {
    digest: {
      type: Object,
    },
  },
  methods: {
    getImage() {
      if (this.digest.image) {
        return this.digest.image;
      }
      return require(`@/assets/illustrations/digest-illust.png`);
    },
    showModal() {
      this.$modal.show("requestReportForm");
    },
    gotoDigest() {
      this.$router.push({
        name: "chartDigest",
        params: {
          id: this.digest.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.digest-card {
  //   width: 30vw;
  background: #ffffff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding-bottom: 3rem;

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    box-shadow: 4px 4px 20px rgba(120, 156, 172, 0.4);
    padding: 10px 14px;
  }

  &__button {
    &:not(:first-child) {
      margin-top: 9px;
    }
  }

  &__body {
    background: #006fa2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 43px 13px;
    min-height: 20rem;
  }

  &__title {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    & > span {
      white-space: nowrap;
    }
  }

  &__text {
    font-size: 14px;
    font-weight: 600;
    color: #00557c;

    &--sm {
      font-size: 12px;
      opacity: 0.6;
      font-weight: 400;
    }
  }

  &__illust {
    z-index: 2;
    position: absolute;
    top: 0;
    left: -17px;
    width: 100px;

    &-wrapper {
      width: 75px;
      height: 75px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        width: 75px;
        height: 75px;
        background: #ffffff;
        border-radius: 50%;
        opacity: 0.2;
      }
    }
  }

  &__logo {
    width: 90px;
		margin-top: 4px;
  }

  &__info {
    width: 60%;
  }
}
</style>
